import Observer from 'common/scripts/observer';
import Utils from 'common/scripts/utils';

const firstScreen = document.querySelector('.j-main-screen');
const firstScreenBtn = document.querySelector('.j-main-screen-btn');
const nextScr = document.querySelector('.j-main-next-scr');
const openedPopup = document.querySelector('.popup.is-open');
const complexTitle = document.querySelector('.j-complex-title');
const menu = document.querySelector('.j-burger-menu');
const navChoose = document.querySelector('.j-navigation-choose');
const observer = new Observer();

const operatePicture = (state) => {
    if (nextScr && !openedPopup && state === 'show') {
        complexTitle.classList.add('is-active');
        nextScr.classList.remove('is-closed');
        nextScr.classList.add('is-active');
        document.querySelector('.j-header').classList.add('is-open-img');
    }

    if (state === 'hide' && !nextScr.classList.contains('is-closed')) {
        complexTitle.classList.remove('is-active');
        nextScr.classList.remove('is-active');
        nextScr.classList.add('is-closed');
        document.querySelector('.j-header').classList.remove('is-open-img');
    }
};

const operateScrollDown = () => {
    if (Utils.getWindowWidth() <= 960) {
        return;
    }

    let scrollsCounter = 0;
    let animationEnded = false;

    window.addEventListener('wheel', (event) => {
        if (Utils.isInViewport(firstScreen) && event.deltaY > 0) {
            if ((menu && menu.classList.contains('is-open')) ||
                (navChoose && navChoose.classList.contains('is-open')) || animationEnded) {
                return;
            }

            event.preventDefault();
            Utils.bodyFixed(firstScreen);
            scrollsCounter++;

            if (scrollsCounter >= 3) {
                operatePicture('show');
                setTimeout(() => {
                    Utils.bodyStatic();
                    scrollsCounter = 0;
                    animationEnded = true;
                }, 3000);
            }
        }

        if (Utils.isInViewport(firstScreen, 150) && event.deltaY < 0) {
            operatePicture('hide');
            animationEnded = false;
        }
    }, {passive: false});
};

if (firstScreenBtn) {
    if (Utils.getWindowWidth() > 960) {
        observer.subscribe('scrollbyStart', () => {
            operatePicture('show');
        });

        operateScrollDown();

        firstScreenBtn.addEventListener('click', () => {
            operatePicture('show');
            Utils.bodyStatic();
        });
    }
}
